import React from 'react';

import DeviceObject from '../../../components/DeviceObject';

const DeviceItems = (devices) => {
  const devicesMap = devices.map(device => (
    <div key={device.serialNumber} className="card-group__item">
      <div className="card card--secondary">
        <div className="card__content">
          <DeviceObject device={device} showSummary />
        </div>
      </div>
    </div>
  ));

  return (
    <>
      <div className="card-group__item">
        <div className="card card--action-right-at-768">
          <div className="card__content">
            <p>To return a home security device, please visit your nearest Xfinity Store.</p>
          </div>
          <div className="card__action">
            <a href="https://www.xfinity.com/support/service-center-locations?retail=true" target="_blank" rel="noopener noreferrer">Xfinity stores near me</a>
          </div>
        </div>
      </div>
      {devicesMap}
    </>
  );
};

export default DeviceItems;
